// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__19v1S","topArea":"List_topArea__2dmRB","addButton":"List_addButton__1xN4k","listArea":"List_listArea__p5llO","hasFilter":"List_hasFilter__2mv_a"};